import React from 'react';

const dropdownStyles = {
  padding: "10px",
  border: "1px solid #E5E5E5",
  borderTop: "none",
  width: "100%",
  backgroundColor: "#FFF",
  margin: "0 auto",
  flexDirection: "column",
  display: "flex",
  position: "absolute",
}

export default function AddToCalendarDropdown({ children }) {
  return (
    <div className="sm:rounded-lg" style={dropdownStyles}>
      {children}
    </div>
  );
}
